var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("error.403")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t('msg["Required Email Verification"]')))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }